import { useState, useEffect } from "react";
import { Phone, Menu, X, Fuel } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL } from "@/lib/site";

const links = [
  { label: "What To Do", href: "#steps" },
  { label: "Services", href: "#services" },
  { label: "Why Us", href: "#why" },
  { label: "Coverage", href: "#coverage" },
  { label: "Get Help", href: "#request" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 border-b transition-[background-color,border-color] duration-300 ${
        scrolled
          ? "bg-[#F5F3EF]/90 border-black/10 backdrop-blur-md"
          : "bg-[#F5F3EF]/70 border-transparent backdrop-blur-sm"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4">
        <a href="#top" data-testid="brand-logo" className="flex items-center gap-2.5">
          <span className="grid h-9 w-9 place-items-center rounded-lg bg-[#1F7A6B] text-white">
            <Fuel strokeWidth={2.5} className="h-5 w-5" />
          </span>
          <span className="font-heading text-xl tracking-tight">
            Fuel<span className="text-[#1F7A6B]">Hero</span>
          </span>
        </a>

        <nav className="hidden items-center gap-8 lg:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-sm font-medium text-[#171717]/80 hover:text-[#1F7A6B] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href={`tel:${PHONE_TEL}`}
          data-testid="navbar-call-button"
          className="hidden md:inline-flex items-center gap-2 rounded-full bg-[#1F7A6B] px-5 py-2.5 text-sm font-semibold text-white hover:bg-[#185f54] transition-colors"
        >
          <Phone strokeWidth={2.5} className="h-4 w-4" /> {PHONE_DISPLAY}
        </a>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="grid h-10 w-10 place-items-center rounded-lg border border-black/10 bg-white lg:hidden"
          aria-label="Menu"
        >
          {open ? <X strokeWidth={2.5} /> : <Menu strokeWidth={2.5} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="border-t border-black/10 bg-[#F5F3EF] lg:hidden">
          <div className="flex flex-col gap-1 px-5 py-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-4 py-3 font-medium hover:bg-white transition-colors"
              >
                {l.label}
              </a>
            ))}
            <a
              href={`tel:${PHONE_TEL}`}
              className="mt-1 rounded-full bg-[#1F7A6B] px-4 py-3 text-center font-semibold text-white"
            >
              Call {PHONE_DISPLAY}
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
